class ValetInventoryService {
	constructor(client) {
		this.apiClient = client;
	}

  async getValetInventoryData(entityID, offset, limit, cancelToken) {
    return this.apiClient.get(`valetinventory/${entityID}/${offset}/${limit}`, cancelToken);
  }	
  
  async getValetTicketDetails(transactionID, cancelToken) {
	return this.apiClient.get(`valetinventory/details/${transactionID}`, cancelToken);
  }

  async getValetTransactionHistory(transactionId, cancelToken) {
	return this.apiClient.get(`valetinventory/history/${transactionId}`, cancelToken);
  }

  async getValetInventorySearch(entityID, minEntranceTime, searchTerm, searchContext, searchStatus, limit, offset, cancelToken) {
	return this.apiClient.get(`valetinventory/search/${entityID}`, {
		params: {
			SearchContext: searchContext,
			MinEntranceTime: minEntranceTime,
			SearchTerm: searchTerm || undefined,
			SearchStatusIDs: searchStatus,
			Limit: limit ?? 10,
			Offset: offset ?? 0
		}
	}, cancelToken);
  }

  async getValetInventoryHistoricalSearch(
    entityID,
    minEntranceTime,
    maxEntranceTime,
    searchContexts,
    guestTypeID,
    searchTerm,
    limit = 10,
    offset = 0,
    sortBy,
    sortDirection,
    cancelToken
  ) {
    return await this.apiClient.post(`valetinventory/historical/search/${entityID}`, searchContexts, {
      params: {
        minEntranceTime: minEntranceTime,
        maxEntranceTime: maxEntranceTime,
        guestTypeID: guestTypeID,
        searchTerm: searchTerm,
        limit: limit,
        offset: offset,
        sortBy: sortBy,
        sortDirection: sortDirection,
      },
      headers: { "Content-Type": "application/json" },
    }, cancelToken);
  }
}

export default ValetInventoryService;